import React, { useState, useEffect, useRef } from 'react';
import SearchBar from '../../../revampComponents/Atom/SearchBar';

const SelectExhibitorCategoryModal = ({
    isOpen,
    onClose,
    data,
    toggleLabel = "exhibitor",
    alreadySelected = [],
    onSelect // Callback to pass selected items back
}) => {
    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState(data || []);
    const [selectedItems, setSelectedItems] = useState([]);
    const dropdownRef = useRef(null);

    const availableData = filteredData || [];

    const setFilterFunction = (value) => {
        if (value) {
            const temp = data?.filter((val) =>
                (val?.entity_name || val?.category_name || '')
                    .toLowerCase()
                    .includes(value?.toLowerCase()?.trim())
            );
            setFilteredData(temp || []);
        } else {
            setFilteredData(data || []);
        }
        setSearch(value);
    };

    const handleSelectItem = (item) => {
        const itemId = item?.category_id || item?.id;
        const isSelected = selectedItems?.some(
            (selected) => (selected?.category_id || selected?.id) === itemId
        );

        let updatedSelection;
        if (isSelected) {
            // Remove item
            updatedSelection = selectedItems?.filter(
                (selected) => (selected?.category_id || selected?.id) !== itemId
            );
        } else {
            // Add item
            updatedSelection = [...selectedItems, item];
        }

        setSelectedItems(updatedSelection);

        // Call onSelect immediately to update parent
        if (onSelect) {
            onSelect(updatedSelection);
        }
    };

    const handleSelectAll = () => {
        const updatedSelection =
            selectedItems?.length === availableData?.length ? [] : [...availableData];
        setSelectedItems(updatedSelection);

        // Call onSelect immediately to update parent
        if (onSelect) {
            onSelect(updatedSelection);
        }
    };

    useEffect(() => {
        if (!isOpen || !dropdownRef.current) return;

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };
        const timer = setTimeout(() => {
            document.addEventListener('mousedown', handleClickOutside);
        }, 100);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    // Initialize selected items when modal opens
    useEffect(() => {
        if (isOpen) {
            setSelectedItems(alreadySelected || []);
        }
    }, [isOpen, alreadySelected]);

    // Update filtered data when data changes
    useEffect(() => {
        setFilteredData(data || []);
    }, [data]);

    if (!isOpen) return null;

    return (
        <div
            ref={dropdownRef}
            className="position-absolute bg-white shadow rounded p-3 exhibitor-category-list-dropdown"
        >
            <SearchBar
                containerClass="search-container mb-3"
                search={search}
                setSearchFunction={setFilterFunction}
                searchPlaceholder={
                    toggleLabel === "exhibitor"
                        ? "Search exhibitors..."
                        : "Search categories..."
                }
            />

            {availableData?.length > 0 && (
                <div className="form-check-task-exhibitor d-flex align-items-center mb-2">
                    <input
                        className="form-check-task-exhibitor-input"
                        type="checkbox"
                        id="select-all"
                        checked={
                            selectedItems?.length > 0 &&
                            selectedItems?.length === availableData?.length
                        }
                        onChange={handleSelectAll}
                    />
                    <label className="form-check-task-exhibitor-label mb-0" htmlFor="select-all">
                        Select All
                    </label>
                </div>
            )}

            {availableData?.length > 0 ? (
                availableData?.map((item) => {
                    const itemId = item?.category_id || item?.id;
                    const isSelected = selectedItems?.some(
                        (selected) => (selected?.category_id || selected?.id) === itemId
                    );

                    return (
                        <div key={itemId} className="form-check-task-exhibitor mb-2">
                            <input
                                className="form-check-task-exhibitor-input"
                                type="checkbox"
                                id={`item-${itemId}`}
                                checked={isSelected}
                                onChange={() => handleSelectItem(item)}
                            />
                            <label className="form-check-task-exhibitor-label mb-0" htmlFor={`item-${itemId}`}>
                                {item?.entity_name || item?.category_name}
                            </label>
                        </div>
                    );
                })
            ) : (
                <p className="text-muted">No items found.</p>
            )}
            <style>{`
                .exhibitor-category-list-dropdown {
                    width: 400px;
                    z-index: 1050;
                    max-height: 300px;
                    overflow-y: auto;
                    border: 1px solid rgb(221, 221, 221);
                    top: 99px;
                    left: auto;
                    right: 29px;
                }
            `}</style>
        </div>
    );
};

export default SelectExhibitorCategoryModal;